/**
 * The shape every "start a reasoning turn" endpoint answers with. `task_id` is
 * the Celery task; older responses (and some flows) only carry `chain_id`,
 * which is a Django AutoField pk and so arrives as a JSON number.
 */
export interface ReasoningTurnStartedResponse {
  task_id?: string | null;
  chain_id?: string | number | null;
}

/**
 * The id to poll / track a freshly started reasoning turn by: `task_id` when
 * present, else `chain_id`, always as a string (the run tracker and
 * `useChatProgress` compare ids as strings). Empty values count as absent.
 * Returns null when the response carries neither.
 */
export function resolveTaskId(
  data: ReasoningTurnStartedResponse
): string | null {
  if (data.task_id) {
    return data.task_id;
  }
  if (
    data.chain_id === undefined ||
    data.chain_id === null ||
    data.chain_id === ''
  ) {
    return null;
  }
  return String(data.chain_id);
}
